import { Box, Flex, Text, useTheme } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { CheckBox_v2 as CheckBox } from 'wg-fe-ui';
import { RootState } from '../../store/redux/reducers/rootReducer';
import { setSendMailToProspect } from '../../store/redux/slices/offersSlice';
import useTracking from '../../../../common/src/hooks/tracking/useTracking';
import RequestTheseOffersButton from './RequestTheseOffersButton';
import { isSocialLoginUrl } from '../../../../app/src/features/authentication/constants/SocialAuth';

const SelectedOffersFooter: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  const { trackEvent } = useTracking();
  const dispatch = useDispatch();
  const offersInfo = useSelector((state: RootState) => state.offers.offersInfo);

  const handleChange = () => {
    if (!offersInfo.sendMailToProspect) {
      trackEvent('Send offers to client in Sales Conversation');
    }
    dispatch(setSendMailToProspect(!offersInfo.sendMailToProspect));
  };

  return (
    <Flex
      flexDirection={{ base: 'column', mobileL: 'row' }}
      justifyContent={isSocialLoginUrl ? 'flex-end' : 'space-between'}
      mt={6}
      alignItems="center"
    >
      {!isSocialLoginUrl && (
        <Box mr={{ base: '0', mobileL: '2' }} mb={{ base: '4', mobileL: '0' }}>
          <Box
            sx={{
              div: {
                border: `2px solid ${
                  offersInfo.sendMailToProspect
                    ? colors.primary[500]
                    : colors.gray[300]
                }`,
                minWidth: '2.5rem',
                minHeight: '2.5rem',
              },
            }}
          >
            <CheckBox
              checked={offersInfo.sendMailToProspect}
              onChange={handleChange}
            >
              <Text textStyle="normalBody">
                {t('Send offers to customer via email')}
              </Text>
            </CheckBox>
          </Box>
        </Box>
      )}
      <RequestTheseOffersButton />
    </Flex>
  );
};

export default SelectedOffersFooter;
